import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Equipamento } from '../../../../types/Equipamento.type';

@Injectable({
  providedIn: 'root'
})
export class EquipamentosService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll() {
    return this.httpClient.get<Equipamento[]>(this.configService.getApiUrlRoot() + "/equipamentos/");
  }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/equipamentos/relatorios/exportar`, { responseType: 'blob' })
  }

}
